import { washData_indexCase } from '@/components/widgets/index_case/washData.js'
import { washData as washDataHomeProductList } from '@/components/widgets/home_product_list/washData.js'
import { washData as washDataListDownloadWidget } from '@/components/widgets/list_download_widget/washData.js'
import { washData as washDataProductIntro } from '@/components/widgets/product_intro/washData.js'
import { washData_listNews } from '@/components/widgets/list_news/washData.js'
import { washData_productImgText } from '@/components/widgets/product_imgText/washData.js'
import { washData_productImgText1 } from '@/components/widgets/product_imgText_style1/washData.js'
import { washData_productImgText2 } from '@/components/widgets/product_imgText_style2/washData.js'
import { washData_productImgText3 } from '@/components/widgets/product_imgText_style3/washData.js'
import { washData_expandCollapseTags } from '@/components/widgets/expand_collapse_tags/washData.js'
import { washData_expandCollapseText } from '@/components/widgets/expand_collapse_text/washData.js'
import { washData_relatedCarouselProduct } from '@/components/widgets/related_carousel_product/washData.js'
import { washData as washDataHomeProductListFive } from '@/components/widgets/home_product_list_five/washData.js'
import { washData_relatedCarouselNews } from '@/components/widgets/related_carousel_news/washData.js'
import { washData_relatedCarouselCase } from '@/components/widgets/related_carousel_case/washData.js'
import { washData_relatedCarouselFaq } from '@/components/widgets/related_carousel_faq/washData.js'
import { washData_rowCol } from '@/components/widgets/rowCol/washData.js'
import { washData_bannerItem } from '@/components/widgets/banner_item/washData.js'
import { washData as washHead } from '@/components/widgets/head_one/washData.js'
import { washData_footModule } from '@/components/widgets/foot_module/washData.js'
import {washData_scrollText} from "@/components/widgets/text_scrollText/washData.js";
import {washData_textTitle} from "@/components/widgets/text_title/washData.js";
import {washData_textParagraph} from "@/components/widgets/text_paragraph/washData.js";
import { washData_nav } from '@/components/widgets/nav/washData.js'
import { washData as washCaseDetail } from '@/components/widgets/case_detail/washData.js'
import { washData as washNewsDetail } from '@/components/widgets/news_detail/washData.js'
import { washData as washCertList } from '@/components/widgets/list_cert_widget/washData.js'
import { washData as washNewsTabOne } from '@/components/widgets/news_tab_one/washData.js'
import { washData as washNewsTabTwo } from '@/components/widgets/news_tab_two/washData.js'
import { washData as washNewsTab } from '@/components/widgets/news_tab/washData.js'
import { washData as washProduct11 } from '@/components/widgets/list_product/style11/washData.js'

export function portOfWashDataAssembly(walkedNode) {
  if (walkedNode.componentName === 'list_news') {
    washData_listNews(walkedNode)
  }
  else if (walkedNode.componentName === 'text_scrollText') {
    washData_scrollText(walkedNode)
  }
  else if (walkedNode.componentName === 'text_title') {
    washData_textTitle(walkedNode)
  }
  else if (walkedNode.componentName === 'text_paragraph') {
    washData_textParagraph(walkedNode)
  }
  else if (walkedNode.componentName === 'index_case') {
    washData_indexCase(walkedNode)
  } else if (walkedNode.componentName === 'home_product_list') {
    washDataHomeProductList(walkedNode)
  } else if (walkedNode.componentName === 'list_download_widget') {
    washDataListDownloadWidget(walkedNode)
  } else if (walkedNode.componentName === 'product_intro') {
    washDataProductIntro(walkedNode)
  } else if (walkedNode.componentName === 'product_imgText') {
    washData_productImgText(walkedNode)
  } else if (walkedNode.componentName === 'product_imgText_style1') {
    washData_productImgText1(walkedNode)
  } else if (walkedNode.componentName === 'product_imgText_style2') {
    washData_productImgText2(walkedNode)
  } else if (walkedNode.componentName === 'product_imgText_style3') {
    washData_productImgText3(walkedNode)
  } else if (walkedNode.componentName === 'expand_collapse_tags') {
    washData_expandCollapseTags(walkedNode)
  } else if (walkedNode.componentName === 'expand_collapse_text') {
    washData_expandCollapseText(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_product') {
    washData_relatedCarouselProduct(walkedNode)
  } else if (walkedNode.componentName === 'home_product_list_five') {
    washDataHomeProductListFive(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_news') {
    washData_relatedCarouselNews(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_case') {
    washData_relatedCarouselCase(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_faq') {
    washData_relatedCarouselFaq(walkedNode)
  } else if (walkedNode.componentName === 'banner_item') {
    washData_bannerItem(walkedNode)
  } else if (walkedNode.componentName === 'head_one') {
    washHead(walkedNode)
  } else if (walkedNode.componentName === 'rowCol') {
    washData_rowCol(walkedNode)
  } else if (walkedNode.componentName === 'foot_module') {
    // washData_footModule(walkedNode)
  } else if (['case_detail_one', 'case_detail_two', 'case_detail'].includes(walkedNode.componentName)) {
    washCaseDetail(walkedNode)
  } else if (['news_detail_three', 'news_detail_two', 'news_detail_one'].includes(walkedNode.componentName)) {
    washNewsDetail(walkedNode)
  } else if (walkedNode.componentName === 'nav') {
    washData_nav(walkedNode)
  } else  if (walkedNode.componentName === 'list_cert_widget') {
    washCertList(walkedNode)
  } else if (walkedNode.componentName === 'news_tab_one') {
    washNewsTabOne(walkedNode)
  } else if (walkedNode.componentName === 'news_tab_two') {
    washNewsTabTwo(walkedNode)
  } else if (walkedNode.componentName === 'news_tab' && walkedNode._type === 'news_tab_3') {
    washNewsTab(walkedNode)
  } else if (walkedNode.componentName === 'list_product' && walkedNode._type === 'list_product_style11') {
    washProduct11(walkedNode)
  }
}
